import { useMutation } from 'react-query';

import { updateProjectAdditionalSpaces } from 'shared/api/projects/http';

const useMutateUpdateProjectAdditionalSpaces = (options = undefined) =>
  useMutation(
    ({ id, specialtySpaces, siteSpecificSpaces }) =>
      updateProjectAdditionalSpaces(id, { specialtySpaces, siteSpecificSpaces }),
    options
  );

export default useMutateUpdateProjectAdditionalSpaces;
